/*
 * @Author: wsx
 * @Date: 2022-01-23 15:48:50
 * @LastEditTime: 2022-01-23 15:50:42
 * @LastEditors: your name
 * @Description:  告警中心
 */
import request from "@/utils/request";


// 历史报警记录--通过条件分页查找-报警内部调用
export const getFindByCondition = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/biz_scene/base/info/findByCondition",
    method: "post",
    data: data
  });
};

// 历史报警记录--处理历史报警
export const getInfoHandle = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/biz_scene/base/info/handle",
    method: "post",
    data: data
  });
};

// 查询报警大类
export const getTypeInfo = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/biz_scene/alarm/type/info",
    method: "get",
    params: data
  });
};

// 通过报警源查询对应的所有报警类型
export const getSourceType = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/biz_scene/type/config/sourceType",
    method: "get",
    params: data
  });
};

// 人脸车辆告警类型通过场所code查询对应的所有报警类型
export const getConfigSourceType = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/biz_scene/type/config/sceneCode",
    method: "get",
    params: data
  });
};

// 人脸车辆告警类型通过场所code查询对应的所有报警类型
export const alarmStatistics = (data, loadingObj) => {
  return request({
    url: "/apiData/hz-data-community/zghz/biz_scene/alarm/type/statistics",
    method: "post",
    data: data,
    ...loadingObj
  });
};